<template>
  <div style="margin-left: 30px; width: 310px;" class="is-flex is-align-items-center is-justify-content-space-between">
    <a @click="previous" class="button is-info is-outlined">Previous</a>
    <div style="width: 0px"></div>
    <p>Page Number {{page}}</p>
    <div style="width: 0px"></div>
    <a @click="next" class="button is-info is-outlined">Next</a>
  </div>
</template>
<script>
export default {
  name: 'paginate-navigation',
  data () {
    return {
      page: this.$route.query.page || 1
    }
  },
  watch: {
    $route () {
      this.page = this.$route.query.page || 1
    }
  },
  methods: {
    previous () {
      let query = { ...this.$route.query }
      if (this.page > 1) {
        query.page = --this.page
      }
      this.$router.push({ name: this.$route.name, query })
    },
    next () {
      let query = { ...this.$route.query }
      query.page = ++this.page
      this.$router.push({ name: this.$route.name, query })
    }
  }
}
</script>
